import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import * as Sentry from '@sentry/browser';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const sentryDsn = window.__ENV__?.SENTRY_DSN;
if (sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        environment: window.__ENV__?.SENTRY_ENVIRONMENT || 'production',
        debug: window.__ENV__?.SENTRY_DEBUG === 'true',
    });
}

// Get the root element from the DOM
const container = document.getElementById('root');

// Create a root
const root = createRoot(container);

// Initial render: Render the <App /> into the root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();